module.exports = __webpack_public_path__ + "img/3.79b98d05.png";